import { PublicationCollectionType } from '@shared/types/enums';
import ApiService from './ApiService';
import { PublicationParams } from '@shared/types/publication';

class PublicationApi extends ApiService {
    constructor() {
        super('publications');
    }

    getPublications(params?: PublicationParams) {
        return this.get('', params);
    }

    getTopPublications(params?: Pick<PublicationParams, 'size' | 'page' | 'categoryCodes' | 'minPrice' | 'maxPrice'>) {
        return this.get('top', params);
    }

    getRecentlyViewedPublications(params?: Pick<PublicationParams, 'size' | 'page'>) {
        return this.get('recently-viewed', params);
    }

    getPublicationDetail(id: string) {
        return this.get(id);
    }

    getPreviewPublicationPage(publicationId: string, pageNumber: number) {
        return this.get(`${publicationId}/preview/${pageNumber}`);
    }

    getPublicationPage(publicationId: string, pageNumber: number) {
        return this.get(`${publicationId}/pages/${pageNumber}`);
    }

    recordReadingHistory(id: string) {
        return this.post(`${id}/read`);
    }

    recordRecentlyViewed(id: string) {
        return this.post(`${id}/view`);
    }

    getUserPublications(params?: { publicationType?: string, size?: number, page?: number, collectionType?: PublicationCollectionType, search?: string, typeSearch?: string }) {
        return this.get('bookshelf', params);
    }

    selectPublication(publicationId: string | number) {
        return this.post('select', { publicationId });
    }
}

const publicationApi = new PublicationApi();
export default publicationApi;
